import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import Spinner from "../../components/ui/Spinner";
import {
    API_BASE_URL,
    API_URL,
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
} from "../../utilities/constants";
import { useLocation, useNavigate, useParams } from "react-router";
import useQueryParams from "../../hooks/useQueryParams";
import { handleApiCall, jsonToQueryParams } from "../../utilities/helper";
import { useUI } from "../../context/UI";

const TemplateDetails = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(false);
    const navigate = useNavigate();
    const { queryParams } = useQueryParams();
    const location = useLocation();
    const { id } = useParams();
    const {
        setSegmentTitle,
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();
    const [controller, setController] = useState(null);

    const callListApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {
            const query = jsonToQueryParams({
                search: queryParams.get("search") || "",
            });
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/template/${id}`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
            } else {
                setData(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        callListApi();
        setSegmentTitle("Template Details");
    }, [location.search]);


    return (
        <>
            <PageMeta
                title={`Template Details - ${DEFAULT_PAGE_TITLE}`}
                description={`Template Details - ${DEFAULT_PAGE_DESCRIPTION}`}
            />
            <div className="flex justify-between items-center mb-4">
                <PageBreadcrumb
                    pageTitle="Template Details"
                    breadcrumbs={[
                        { label: "Templates", path: "/notification" },
                        { label: "Templates Details" }
                    ]}
                />
            </div>
            {loading ? (
                <div className="flex justify-center items-center">
                    <Spinner />
                </div>
            ) : (

                <div className="p-6 bg-white dark:bg-gray-800 rounded-lg mx-auto h-full">
                    <div className="flex flex-col md:flex-row gap-8">
                        <div className="flex flex-col items-center md:items-start gap-6 w-full md:w-1/4">
                            <div className="space-y-4 w-full">
                                <div>
                                    <h3 className="text-sm text-gray-500 dark:text-gray-400">Template Name</h3>
                                    <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                        {data?.name || "-"}
                                    </p>
                                </div>
                                <div>
                                    <h3 className="text-sm text-gray-500 dark:text-gray-400">Status</h3>
                                    <span
                                        className={`inline-flex px-2 py-1 rounded-full text-xs font-semibold ${data?.statusId === 1
                                                ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-200"
                                                : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-200"
                                            }`}
                                    >
                                        {data?.statusId === 1 ? "Active" : "Inactive"}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Right Column — Content Info */}
                        <div className="flex-1 md:pl-8 md:border-l border-gray-200 dark:border-gray-700">
                            <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">
                                Template Details
                            </h2>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900">
                                    <h3 className="text-sm text-gray-500 dark:text-gray-400">Subject</h3>
                                    <p className="text-base font-medium text-gray-900 dark:text-gray-100 break-words">
                                        {data?.subject || "-"}
                                    </p>
                                </div>

                                <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 col-span-1 sm:col-span-2">
                                    <h3 className="text-sm text-gray-500 dark:text-gray-400">Body</h3>
                                    <p className="text-base font-medium text-gray-900 dark:text-gray-100 whitespace-pre-wrap break-words">
                                        {data?.body || "-"}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                // <div className="p-6 bg-white dark:bg-gray-800 rounded-lg mx-auto h-full">
                //     <div className="flex flex-col md:flex-row gap-8">
                //         <div className="flex flex-col items-center md:items-start gap-6 w-full md:w-1/4">
                //             <div className="space-y-4 w-full">
                //                 <div>
                //                     <h3 className="text-sm text-gray-500 dark:text-gray-400">Full Name</h3>
                //                     <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                //                         {data?.name || "-"} 
                //                     </p>
                //                 </div>
                //             </div>
                //         </div>
                //         <div className="flex-1 md:pl-8 md:border-l border-gray-200 dark:border-gray-700">
                //             <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">
                //                 Measurements
                //             </h2>

                //             <div className="grid grid-cols-2 sm:grid-cols-2 gap-6">
                //                 <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-800">
                //                     <h3 className="text-sm text-gray-500 dark:text-gray-400">Age</h3>
                //                     <p className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                //                         {data?.profile?.profile?.age} <span className="text-sm font-normal">years</span>
                //                     </p>
                //                 </div>

                //                 <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-800">
                //                     <h3 className="text-sm text-gray-500 dark:text-gray-400">Height</h3>
                //                     <p className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                //                         {data?.profile?.profile?.heightCm} <span className="text-sm font-normal">cm</span>
                //                     </p>
                //                 </div>

                //                 <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-800">
                //                     <h3 className="text-sm text-gray-500 dark:text-gray-400">Weight</h3>
                //                     <p className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                //                         {data?.profile?.profile?.weightKg} <span className="text-sm font-normal">kg</span>
                //                     </p>
                //                 </div>

                //                 <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-800">
                //                     <h3 className="text-sm text-gray-500 dark:text-gray-400">Shoe Size</h3>
                //                     <p className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                //                         {data?.profile?.profile?.shoeSize}
                //                     </p>
                //                 </div>
                //             </div>
                //         </div>
                //     </div>
                // </div>


            )}

        </>
    );
};
export default TemplateDetails;